<div (click)="closeDialog({code: ProjectConstants.CANCELLED_ACTION})" class="close-button"></div>
<div class="gain-impact">
  <div class="select-vote">
    {{ (isManagingVotes ? 'RECLAIM.title_1' : 'RECLAIM.title_2') | translate }}
  </div>
</div>

<div class="scrollable">
  <form [formGroup]="reclaimProjectForm" class="info-container">
    <div *ngIf="!isMobile" class="message">
      {{(isManagingVotes ? 'RECLAIM.subtitle_1' : 'RECLAIM.subtitle_2') | translate}}
    </div>

    <div class="voted-projects-list">
      <ng-template [ngForOf]="votedProjects$ | async" let-i="index" let-project="$implicit" ngFor>
        <div *ngIf="isManagingVotes; else radioTemplate" formArrayName="projectCheckboxes">
          <label class="project-item" for="manage-vote-checkbox-{{ i }}">
            <input (change)="onCheckboxChange($event, i)"
                   [formControlName]="i" class="custom-checkbox" id="manage-vote-checkbox-{{ i }}" type="checkbox"/>
            <span class="checkbox-custom">
              <i class="fa-solid fa-check"></i>
            </span>
            <div class="name-tip-location">
              <div class="project-name">{{ project.name[currentLanguage] }}</div>
              <div class="tip-location">
                {{ 'PREFERENCES_POPUP_1.' + project.north_star + '_preferencespopup1' | translate }}
              </div>
              <div class="tip-location">
                {{ 'PREFERENCES_POPUP_2.' + project.continent + '_preferencespopup2' | translate }}
                <ng-container *ngIf="project.country">- {{ 'COUNTRIES.' + project.country | translate }}</ng-container>
              </div>
            </div>
            <div class="reclaim-icon-container">
              <img alt="reclaim" loading="lazy" src="/assets/icons/colibri-reclaim-vote.svg"/>
              <div>{{ 'RECLAIM.button_reclaim' | translate : {plural: ''} }}</div>
            </div>
          </label>
        </div>
        <ng-template #radioTemplate>
          <input [value]="project.id" formControlName="projectId" id="reclaim-vote-radio-{{ i }}" type="radio"/>
          <label class="project-item" for="reclaim-vote-radio-{{ i }}">
            <div class="name-tip-location">
              <div class="project-name">{{ project.name[currentLanguage] }}</div>
              <div class="tip-location">
                {{ 'PREFERENCES_POPUP_1.' + project.north_star + '_preferencespopup1' | translate }}
              </div>
              <div class="tip-location">
                {{ 'PREFERENCES_POPUP_2.' + project.continent + '_preferencespopup2' | translate }}
                <ng-container *ngIf="project.country">- {{ 'COUNTRIES.' + project.country | translate }}</ng-container>
              </div>
            </div>
            <div class="reclaim-icon-container">
              <img alt="reclaim" loading="lazy" src="/assets/icons/colibri-reclaim-vote.svg"/>
              <div>{{ 'RECLAIM.button_reclaim' | translate : {plural: ''} }}</div>
            </div>
          </label>
        </ng-template>
      </ng-template>
    </div>
    <div class="buttons-container">
      <div (click)="closeDialog({code: ProjectConstants.CANCELLED_ACTION})"
           class="take-back-button">{{  (isManagingVotes ? 'RECLAIM.cancel' : 'RECLAIM.back_reclaim') | translate }}</div>
      <div class="ns-mr-16">
        <small
          *ngIf="isManagingVotes ? noProjectSelected : !reclaimProjectForm.valid">{{ 'RECLAIM.no_project_selected_error' | translate }}</small>
        <ns-button
          (callback$)="isManagingVotes ? manageVotes(): changeVote()"
          [disabled]="isManagingVotes ? noProjectSelected : !reclaimProjectForm.valid"
          [styles]="'width: 148px;'"
          [text]="'RECLAIM.button_reclaim' | translate : { plural: selectedProjectsNumber > 1 ? 's': '' }"
          [type]="Constants.BUTTON_TYPE_DEFAULT_YELLOW_SOLID_M">
        </ns-button>
      </div>
    </div>
  </form>
</div>
<div class="mobile-buttons-container">
  <div (click)="closeDialog({code: ProjectConstants.CANCELLED_ACTION})"
       class="take-back-button">{{ 'RECLAIM.cancel' | translate }}</div>
  <div class="ns-ml-6">
    <small
      *ngIf="isManagingVotes ? noProjectSelected : !reclaimProjectForm.valid">{{ 'RECLAIM.no_project_selected_error' | translate }}</small>
    <ns-button
      (callback$)="isManagingVotes ? manageVotes(): changeVote()"
      [disabled]="isManagingVotes ? noProjectSelected : !reclaimProjectForm.valid"
      [styles]="'width: 200px;'"
      [text]="'RECLAIM.button_reclaim' | translate : { plural: selectedProjectsNumber > 1 ? 's': '' }"
      [type]="Constants.BUTTON_TYPE_DEFAULT_YELLOW_FILLED_B">
    </ns-button>
  </div>
</div>
